import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=87c5d7f4&"
import script from "./ImageCropper.vue?vue&type=script&lang=js&"
export * from "./ImageCropper.vue?vue&type=script&lang=js&"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=87c5d7f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports